module.exports = __webpack_public_path__ + "img/img_06_retail@3x.a1e41d06.png";